import React, {useState, useEffect} from "react";
import {connect} from "react-redux"
import NumberFormat from "react-number-format";



const CartItem = (props)=>{

    const [asData, setAsData] = useState(false)
    const [item, setItem] = useState(props.item)
    const [itemTotPrice, setItemTotPrice] = useState(0.0)

    useEffect(()=>{
        setItem(props.item)
    }, [])

    useEffect(()=>{
        setItem(props.item)
        setItemTotPrice(item.price * item.shopQuantity)
    }, [props.item])



    return(
            <li className="list-group-item d-flex flex-column justify-content-between align-items-start">
                <div className={"w-100 text-right"}>
                    <button className={"btn btn-xs btn-light p-1 text-muted"}
                            onClick={(e) => props.removeFromCart(item)}>
                        <i className="fas fa-trash-alt"></i>
                    </button>
                </div>
                <div className="d-flex  flex-row justify-content-between">
                    <span className={"font-weight-bolder"}> {item.name}</span>
                </div>
                <div className="d-flex justify-content-between w-100">
                    <div> Nb. :</div>
                    <div>
                        <span className={"ue-product-amount-btn"}
                              onClick={(e) => props.subQuantityToCart(item)}>-</span>
                        <div className="badge bg-primary rounded-pill mx-2 text-light">{item.shopQuantity}</div>
                        <span className={"ue-product-amount-btn"}
                              onClick={(e) => props.addQuantityToCart(item)}>+</span>
                    </div>
                </div>
                <div className="d-flex justify-content-between w-100 mt-2 font-italic" style={{"fontSize": "0.6rem"}}>
                    <span> H.T. : </span>
                    <span className=" text-muted">
                        <NumberFormat value={itemTotPrice} displayType={'text'}
                                      thousandSeparator={' '} decimalScale={2} suffix={'€'}/>
                    </span>
                </div>
            </li>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
    }
}

const mapDispatchTProps = dispatch => {

    return {
        removeFromCart: (e) => dispatch( {type: 'REMOVE_FROM_CART',  data:{product: e}}),
        addQuantityToCart: (e) => dispatch( {type: 'ADD_QUANTITY', data:{product: e}}),
        subQuantityToCart: (e) => dispatch( {type: 'SUB_QUANTITY', data:{product: e}}),
    }

}

export default connect(mapStateToProps, mapDispatchTProps)(CartItem);



